import { render, staticRenderFns } from "./DepenseList.vue?vue&type=template&id=2baa6572&scoped=true&"
import script from "./DepenseList.vue?vue&type=script&lang=js&"
export * from "./DepenseList.vue?vue&type=script&lang=js&"
import style0 from "./DepenseList.vue?vue&type=style&index=0&id=2baa6572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa6572",
  null
  
)

export default component.exports